import http from "@/plugins/http";
import api from "@/assets/scripts/api";
export function getUserInfo() {
  return http.get(api.auth.userInfo);
}
